import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BidCategoryClient, BidCategoryView, QuickSearchBidCategoriesParameters } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BidCategoryService {
    constructor(private readonly client: BidCategoryClient) {}

    async search(filterText?: string): Promise<BidCategoryView[]> {
        return await lastValueFrom(
            this.client.bidCategoryQuickSearch({
                filterText: filterText
            } as QuickSearchBidCategoriesParameters)
        );
    }

    async getById(id: number): Promise<BidCategoryView> {
        const items = await lastValueFrom(this.client.bidCategoryQuickSearch({} as QuickSearchBidCategoriesParameters));
        const item = items.find((x) => x.id === id);

        if (!item) {
            throw new Error(`BidCategory with id ${id} not found`);
        }

        return item;
    }

    async getByIds(ids: number[]): Promise<BidCategoryView[]> {
        if (!ids.length) return [];

        const items = await lastValueFrom(this.client.bidCategoryQuickSearch({} as QuickSearchBidCategoriesParameters));
        const idsSet = new Set(ids);

        return items.filter((x) => idsSet.has(x.id));
    }
}
